export default "__VITE_ASSET__DGW57BNv__"